<template>
  <div>
    <h1 class="heading">1dCube.io</h1>
    <rubix-cube />
  </div>
</template>

<script>
import rubixCube from "./components/rubixCube";
export default {
  name: "App",
  components: {
    "rubix-cube": rubixCube,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
@font-face {
  font-family: StardewValleyFont;
    src: url(./assets/Stardew\ Valley\ ALL\ CAPS.ttf);
}
.heading {
  font-family: StardewValleyFont;
  font-size: 7vw;
  text-align: center;
}
</style>
